// Supports weights 300-700
import "@fontsource-variable/space-grotesk"

// to add extra props to theme
// declare module "@material-ui/core/Button" {
//   interface ButtonPropsSizeOverrides {
//     extraSmall: true;
//   }
// }

export const materialTheme = (props) => ({
  palette: {
    mode: props.profileTheme,
    ...(props.profileTheme === "light"
      ? {
          background: { default: "#F6F4F2", dark: "#E5E2DE" },
        }
      : {
          background: { default: "#121212", dark: "#1C1B1B" },
        }),
    primary: {
      main: props.profileTheme === "light" ? "#467A33" : "#68A045",
    },
    secondary: {
      main: props.profileTheme === "light" ? "#122380" : "#122380",
    },
  },
  typography: {
    fontFamily: "Space Grotesk Variable, Beatrice, Poppins, sans-serif",
    fontSize: 12,
    letterSpacing: "-0.05em",
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Space Grotesk Variable, Beatrice, Poppins, sans-serif",
          letterSpacing: "-0.05em",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontWeight: 700,
          letterSpacing: "-0.07em",
        },
        h2: {
          fontWeight: 700,
          letterSpacing: "-0.07em",
        },
        h3: {
          fontWeight: 700,
          letterSpacing: "-0.07em",
        },
        h4: {
          fontWeight: 700,
          letterSpacing: "-0.07em",
        },
        h5: {
          fontWeight: 700,
          letterSpacing: "-0.07em",
        },
        h6: {
          fontWeight: 700,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Space Grotesk Variable, Beatrice, Poppins, sans-serif",
          fontSize: "1rem",
          textTransform: "none",
          borderRadius: 500,
          fontWeight: "bolder",
          letterSpacing: "-0.05em",
        },
      },
      defaultProps: {
        size: "large",
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
      defaultProps: {
        elevation: props.profileTheme === "light" ? 1 : 0,
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "0px",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          gap: "24px",
          sx: { fullWidth: true },
          fontWeight: "bolder",
          marginTop: 8,
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          gap: "24px",
          sx: { fullWidth: true },
          fontWeight: "bolder",
          marginTop: 8,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          fullWidth: true,
          lineHeight: "1.2rem",
          "&.Mui-focused": {
            color: theme.palette.text.secondary,
          },
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        fullWidth: true,
        root: ({ theme }) => ({
          width: "100%",
          backgroundColor: theme.palette.background.paper,
          fontWeight: "bolder",
          marginTop: 8,
          // Hide arrow/spin buttons for input[type=number] for chrome, safari, edge
          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
            {
              WebkitAppearance: "none",
              margin: 0,
            },
          // Hide arrow/spin buttons for input[type=number] for firefox
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: ({ theme }) => ({
          marginTop: 8,
          fontWeight: "bolder",
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        fullWidth: true,
        root: ({ theme }) => ({
          width: "100%",
          backgroundColor: theme.palette.background.paper,
          fontWeight: "bolder",
        }),
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardWarning: ({ theme }) => ({
          border: `1px solid ${theme.palette.warning.light}`,
          borderRadius: 8,
          fontSize: "0.8em",
        }),
        standardInfo: ({ theme }) => ({
          border: `1px solid ${theme.palette.info.light}`,
          borderRadius: 8,
          fontSize: "0.8em",
        }),
        standardSuccess: ({ theme }) => ({
          border: `1px solid ${theme.palette.success.light}`,
          borderRadius: 8,
          fontSize: "0.8em",
        }),
        standardError: ({ theme }) => ({
          border: `1px solid ${theme.palette.error.light}`,
          borderRadius: 8,
          fontSize: "0.8em",
        }),
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: ({ theme }) => ({
          opacity: "1 !important",
        }),
      },
    },
    MuiRadioGroup: {
      styleOverrides: {
        root: ({ theme }) => ({
          sx: {
            "& .MuiSvgIcon-root": {
              fontSize: 56,
            },
          },
        }),
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ theme }) => ({
          sx: {
            "& .MuiSvgIcon-root": {
              fontSize: 56,
            },
          },
        }),
        sx: {
          "& .MuiSvgIcon-root": {
            fontSize: 56,
          },
        },
      },
    },
    MuiTimelineItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&:before": {
            display: "none",
          },
        }),
      },
    },
  },
})
